import styled from 'styled-components';

interface T1Props {
	// contentColor?: ContentColor;
	// fontWeight?: FontWeight;
	// fontStyle?: FontStyle;
	'data-test-id'?: string;
}

const T1 = styled.p<T1Props>`
	font-weight: normal;
	font-size: 1.3rem;
	line-height: 170%;
	letter-spacing: 0.5px;
	margin: 0;
	font-style: normal;
	color: black;
`;

export default T1;
